<!--
 * @Author: 汪俊洪
 * @Date: 2025-04-27 10:41:05
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-04-27 19:44:15
 * @Description:
-->
<template>
  <div class="wrap">
    <el-table
      class="plc-table"
      height="100%"
      :data="tableData"
      style="width: 100%"
      row-key="plcSkuId"
      v-loading="loading"
    >
      <el-table-column
        prop="date"
        header-align="center"
        width="370px"
        label="商品信息"
      >
        <template slot-scope="scope">
          <div class="goods-info">
            <el-image
              class="fileUrl"
              :src="scope.row.fileUrl || defaultImg"
              :preview-src-list="scope.row.fileUrl ? [scope.row.fileUrl] : null"
            >
              <div slot="error">
                <el-image class="img" :src="defaultImg" :fit="'contain'"> </el-image>
              </div>
            </el-image>
            <div class="goods-right">
              <h2 class="skuName ell_two">{{ scope.row.skuName }}</h2>
              <div class="plc-des">
                <span class="plc-des-label">型号：</span>
                <span class="plc-des-value">{{ scope.row.model }}</span>
              </div>
              <div class="plc-des">
                <span class="plc-des-label">规格：</span>
                <span class="plc-des-value">{{ scope.row.specification }}</span>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="discountSellingPrice"
        label="单价（元）"
      >
        <template slot-scope="scope">
          <div class="plc-des">
            <span class="plc-des-label">价格：</span>
            <span class="plc-des-value discountSellingPrice"
              >￥{{ scope.row.discountSellingPrice | formatePrice }}</span
            >
          </div>
          <div class="plc-des">
            <span class="plc-des-label">折扣：</span>
            <span class="plc-des-value"
              >{{ (scope.row.discountRate || 0) * 10 }}折</span
            >
          </div>
          <div class="plc-des">
            <span class="plc-des-label">标准价：</span>
            <span class="plc-des-value">{{
              scope.row.sellingPrice | formatePrice
            }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="plcSkuCode" align="center" label="中控物料编码">
      </el-table-column>
      <el-table-column prop="skuCode" align="center" label="平台编码">
      </el-table-column>
      <el-table-column prop="goodsNum" align="center" label="数量">
        <template slot-scope="scope">
          <el-input-number
            size="mini"
            class="plc-input-number"
            v-model="scope.row.goodsNum"
            :min="1"
            :max="99999999"
            @change="changeNum(scope.row)"
          ></el-input-number>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { formatePrice } from '@/utils/formatePrice'
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatePrice (val) {
      if (val) {
        if (typeof val !== 'number') {
          val = val - 0
        }
        return formatePrice(val.toFixed(2))
      }
      if (val === null) {
        return '-'
      }
      return '0.00'
    }
  },
  data () {
    return {
      defaultImg: require('@/assets/img/goods_default.png')
    }
  },
  methods: {
    changeNum (row) {
      this.$emit('changeNum', row)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrap {
  padding-top: 9px;
  height: 100%;
}
.goods-info {
  display: flex;
  align-items: center;
  .fileUrl {
    width: 131px;
    margin-right: 16px;
  }
  .skuName {
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    margin: 0 0 14px;
  }
  .goods-right {
    flex: 1;
  }
}

.plc-des {
  text-align: left;
  margin-bottom: 9px;
}

.discountSellingPrice {
  font-size: 20px;
  font-weight: 900;
  color: #e93037;
}
</style>
